import {ILogService, IScope} from "angular";

export interface ILoadingServiceRootScope extends IScope {
    stateLoading: boolean;
}

export class LoadingService {
    /* @ngInject */
    constructor(private $log: ILogService, private $rootScope: ILoadingServiceRootScope) {
        this.hide();
    }

    public show() {
        this.$rootScope.stateLoading = true;
    }

    public hide() {
        this.$rootScope.stateLoading = false;
    }

    public isLoading() {
        return this.$rootScope.stateLoading;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/loading/loading.service.ts